import { gql, useQuery } from "@apollo/client"
import { ApplicationsPageModel } from "../../components/contentful/models"
import { client, enablePreview } from "../../graphql/contentful/client"
import { ContentfulEntryTypeName } from "../../components/contentful/entries"
import { RICH_TEXT_CONTENT } from "../news/useArticle"
import { useContentfulLiveUpdates } from "@contentful/live-preview/react"

export interface ApplicationsPageQuery {
  applicationsPage: ApplicationsPageModel<ContentfulEntryTypeName>
}

const QUERY_APPLICATIONS_PAGE = gql`
  query getApplicationsPage($preview: Boolean!) {
    applicationsPage(id: "1Mmmx9V0ABpg1NSH4Zn5qv", preview: $preview) {
      __typename
      sys {
        id
      }
      metadata {
        title
        type
        description
        tags
        relatedLinks
      }
      hero {
        title
        showTitle
        subtitle
        image {
          sys {
            id
          }
          url(
            transform: {
              format: WEBP
              quality: 100
              width: 2400
              height: 720
            }
          )
          description
        }
      }
      title
      ${RICH_TEXT_CONTENT}
      casesCollection {
        items {
          sys {
            id
          }
          color
          title
          description
          slug
          externalLink
          externalLinkText
          hero {
            sys {
              id
            }
            showTitle
            title
            subtitle
            image {
              url(
                transform: {
                  format: WEBP
                  quality: 70
                  width: 800
                }
              )
              description
            }
          }
        }
      }
    }
  }
`

export function useApplicationsPage() {
  const { data, error, loading } = useQuery<ApplicationsPageQuery>(QUERY_APPLICATIONS_PAGE, {
    client,
    variables: {
      preview: enablePreview,
    },
  })

  const applications = data?.applicationsPage

  return {
    applications,
    error,
    loading,
    query: QUERY_APPLICATIONS_PAGE,
  }
}
